export const menuItems = [
    {
        to: '/main',
        text: 'Главная'
    },
    {
        to: '/planning',
        text: 'Планирование'
    },
    {
        to: '/rewards',
        text: 'Награды'
    },
        {
        to: '/contacts',
        text: 'Контакты'
    },
];